import React from "react";

import styles from "./ResetSearchButton.module.scss";
import {useDispatch} from "react-redux";
import {RESET_SEARCH} from "../../Store/Actions/ActionTypes";
import {updateMainFacetsCount} from "../../Store/Actions/NewFilterActions";
import {HIDE_MENU} from "../../Store/Actions/ActionTypes";

const ResetSearchButton = () => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch({type: RESET_SEARCH});
        dispatch(updateMainFacetsCount(""));
        dispatch({type:HIDE_MENU});
    };

    return (
        <button className={styles.wrapper} onClick={handleClick}>Fjern alle filter<span>×</span></button>
    )
}
export default ResetSearchButton;
